export default {
  'Start at': '音樂開始於',
  'Set to current time': '設置為當前時間',
  'Audio volume': '音訊音量',
  'Video volume': '影片音量',
  'Trim audio': '剪輯音訊',
  'Audio will end with the video': '音訊會隨著影片的結束而結束。',
  'Trim': '修剪',
}